import { ListMenu } from "../../common/components/ListMenu";
import React from "react";
import {useDebouncedSearch, useQueryWithPagination} from "../../utils/Hooks";
import { AxiosPositionsAPI } from "../Api";
import { useAuth, userActiveView } from "../../utils/Auth";
import { Row } from "antd";
import PositionAddModal from "./PositionAddModal";
import { PositionListRoutes } from "../Routes";

export function PositionListLayout() {
  const { user } = useAuth();
  const [search, debouncedSearch, setSearch] = useDebouncedSearch();
  const positionData = useQueryWithPagination({
    queryKey: ["position-list-layout", debouncedSearch],
    queryFn: AxiosPositionsAPI.getAll,
    search: debouncedSearch,
  });

  return (
    <div>
      <ListMenu search={search} setSearch={setSearch} />
      {userActiveView(user) && (
        <Row justify="end">
          <PositionAddModal reload={positionData.refetch} />
        </Row>
      )}
      <PositionListRoutes search={debouncedSearch} positionData={positionData} />
    </div>
  );
}
